import { Theme } from 'config';

const styles = (theme: Theme) => ({
  divider: {
    border: '1px solid #f7f8f9',
    width: '100%',
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'center !important',
  },
  container: {
    border: 'none !important',
    margin: '.625rem 0 !important',
    padding: '1.25rem !important',
    width: '100% !important',
    position: 'relative !important',
  },
  header: {
    color: `${theme.deepPurple} !important`,
    fontSize: '1.25rem !important',
    textAlign: 'left !important',
    paddingBottom: '.75rem !important',
  },
  textLabel: {
    fontSize: '1.1rem',
    marginRight: '.5rem',
    fontWeight: 'bold',
  },
  formGrid: {
    margin: '0 !important',
  },
  formRow: {
    padding: '.5rem 0 !important',
  },
  fieldLabel: {
    color: '#646464 !important',
    fontSize: '.875rem !important',
    fontWeight: '500 !important',
    margin: '0 0 .30rem 0',
    display: 'block !important',
  },
  fieldGroup: {
    width: '100%',
    marginTop: '.65rem !important',
    justifyContent: 'center !important',
  },
  label: {
    color: '#4a4a4a !important',
    fontSize: '1.1rem !important',
    marginRight: '1rem !important',
  },
  address: {
    color: 'black',
  },
  cardHeader: {
    color: 'black',
  },
  clientWrapper: {
    display: 'flex !important',
    flexDirection: 'row !important',
    justifyContent: 'flex-start !important',
  },

  spacer: {
    paddingRight: '.75rem !important',
  },
  editLink: {
    marginTop: '1.25rem',
    fontWeight: '500 !important',
  },
  smallDropDown: {
    width: '31% !important',
  },
  button: {
    backgroundColor: `${theme.coral} !important`,
    borderRadius: '1.5em !important',
    color: '#fff !important',
    marginTop: '1rem !important',
    height: '3.125rem',
    fontWeight: 'bold !important',
    width: '100%',
    outline: 0,
    border: 'none !important',
    '&:hover': {
      boxShadow:
        '0 0 0 .0625rem transparent inset,0 0 0 0 rgba(34,36,38,.15) inset !important',
      opacity: 0.9,
    },
    '&:active': {
      opacity: 0.7,
    },
  },
  buttonSecondary: {
    marginRight: '.45rem !important',
    backgroundColor: `${theme.softGray} !important`,
    color: `${theme.darkGray} !important`,
    height: '3.125rem',
    '&:hover': {
      boxShadow:
        '0 0 0 .0625rem transparent inset,0 0 0 0 rgba(34,36,38,.15) inset !important',
      opacity: 0.9,
    },
    '&:active': {
      opacity: 0.7,
    },
  },
  mediumBtn: {
    width: '48% !important',
  },

  dateLabel: {
    display: 'block !important',
    fontFamily: 'DOSH !important',
    color: '#4a4a4a !important',
    fontWeight: '400 !important',
  },
  datePickerWrapper: {
    '& .DayPickerInput': {
      width: '100% !important',
    },
    '& .DayPickerInput input': {
      width: '100% !important',
      margin: 0,
      maxWidth: '100%',
      outline: 0,
      textAlign: 'left',
      lineHeight: '1.21428571em',
      fontFamily: 'DOSH !important',
      padding: '.67857143em 1em',
      background: '#fff',
      border: '0.0625rem solid rgba(34,36,38,.15)',
      color: 'rgba(0,0,0,.87)',
      borderRadius: '.28571429rem',
    },
  },

  '@global .selectable .DayPicker-Caption': {
    fontSize: '1.125em',
    color: '#683caf',
  },
  '@global .selectable .DayPicker-Caption > div': {
    fontWeight: 'normal',
  },
  '@global .selectable .DayPicker-Day--selected': {
    backgroundColor: '#683caf !important',
    borderRadius: '50% !important',
    color: '#fff !important',
  },
  '@global .selectable .DayPicker-Day:hover': {
    backgroundColor: 'rgb(104,60,175, .15)!important',
    borderRadius: '50% !important',
  },
  '@global .selectable .DayPicker-Day--today': {
    color: '#f4897d !important',
  },
});

export default styles;
